import { DELIVERY_SALE_TYPES } from '../libs/polygon-ordering/src/constants';
import { OrderingConstants } from 'polygon-ordering';

const { SALE_TYPE } = OrderingConstants;

export default function (saleType: SALE_TYPE) {
  const isPickupOrTakeAway =
    saleType === SALE_TYPE.PICKUP ||
    saleType === SALE_TYPE.TAKE_AWAY ||
    saleType === SALE_TYPE.CATERING ||
    saleType === SALE_TYPE.APP_LANE_PICKUP;
  const isDelivery = DELIVERY_SALE_TYPES.includes(saleType);
  const isDineIn = saleType === SALE_TYPE.DINE_IN || saleType === SALE_TYPE.TABLE_ORDER;

  return {
    isPickupOrTakeAway,
    isDelivery,
    isDineIn,
  };
}
